import React from "react";
import { useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import RangeDatePicker from "./RangeDatePicker";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import colors from "../../config/colors";
import repairImg from "../../assets/img/repair.png";
import installImg from "../../assets/img/schedule-job-icon.png";
import installImage from "../../assets/img/install.png";
import removalImg from "../../assets/img/schedule-x-icon.PNG";


export default () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [reqType, setReqType] = useState("Request Type");
  const [requests, setRequest] = useState();

  const handleChange = (key, value) => {
    if (key !== "message") {
      setReqType(`${key} Request`);
    } else {
      const message = document.getElementById("message");
      const listener = (e) => {
        setRequest({
          ...requests,
          message: e.target.value,
        });
      };
      message.addEventListener("input", listener);
      return () => message.removeEventListener("input", listener);
    }
  };

  const { request, loading, error } = useApi((resultData) =>
    apiClient.post("/installerRequest", resultData)
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    const resultData = {
      request_type: reqType,
      message: requests.message,
    };
    const result = await request(resultData);
    if (result.status === 200) {
      toast.success("Account Succesfully Created");
    } else {
      toast.error("Error");
    }
  };

  const installerRequests = [
    {
      dateTime: "12/16/2022; 2:00pm",
      location: "Madison Square Garden,",
      earnings: "$600.00",
      buttonText: "Repair",
      image:  require("../../assets/img/repairGray.png"),
    },
    {
      dateTime: "12/16/2022; 2:00pm",
      location: "Madison Square Garden,",
      earnings: "$600.00",
      buttonText: "Install",
      image:  require("../../assets/img/installGray.png"),
    },
    {
      dateTime: "12/15/2022; 1:00pm",
      location: "Sofi Stadium, Inglewood, CA",
      earnings: "$450.00",
      buttonText: "Removal",
      image:  require("../../assets/img/removalGray.png"),
    },
    {
      dateTime: "12/15/2022; 1:00pm",
      location: "Sofi Stadium, Inglewood, CA",
      earnings: "$450.00",
      buttonText: "Repair",
      image:  require("../../assets/img/repairGray.png"),
    },
  ];
  return (
    <div>
      <div className="site-content h-100">
        <div className="site-content-body">
          <div className=" position-relative">
            {/*-----------------------------
                                  Start || Payment section
                              ----------------------------- */}
            <section className="req-sec main-sec border py-3">
              <div className="container">
                <form onSubmit={handleSubmit}>
                  {/* ----------Request textarea--------- */}
                  <div className=" d-md-flex justify-content-between mt-3 make_res">
                    <div className="req-field d-sm-flex w-100 pe-md-3">
                      <div className="req-btn px-2">
                        <div className="dropdown">
                          <button
                            className="btn btn-secondary shadow-none dropdown-toggle text-secondary"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {reqType}
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li
                              onClick={() => handleChange("Install", "install")}
                            >
                              <a
                                className="dropdown-item "
                                href="#"
                                style={{ color: colors.primary }}
                              >
                                <img
                                  src={installImg}
                                  alt=""
                                  className="img-fluid me-1"
                                />
                                Install
                              </a>
                            </li>
                            <li
                              onClick={() => handleChange("Removal", "removal")}
                            >
                              <a
                                className="dropdown-item "
                                href="#"
                                style={{ color: colors.primary }}
                              >
                                <img
                                  src={removalImg}
                                  alt=""
                                  className="img-fluid"
                                />
                                Removal
                              </a>
                            </li>
                            <li
                              onClick={() => handleChange("Repair", "repair")}
                            >
                              <a
                                className="dropdown-item  "
                                href="#"
                                style={{ color: colors.primary }}
                              >
                                <img
                                  src={repairImg}
                                  alt=""
                                  className="img-fluid"
                                />
                                Repair
                              </a>
                            </li>
                            <li
                              onClick={() => handleChange("Other", "other")}
                              className="ps-1"
                            >
                              <a
                                className="dropdown-item   "
                                href="#"
                                style={{ color: colors.primary }}
                              >
                                <FaQuestionCircle color="black" size={22} />{" "}
                                other.....
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <textarea
                        name
                        onChange={(e) =>
                          handleChange("message", e.target.value)
                        }
                        id="message"
                        className="py-1 px-1 d-block blue-txt w-100 bg-white"
                        placeholder="Type your message to Rolling Adz here..."
                      />
                    </div>
                    <div className="d-flex req-btns mt-3 mt-md-0 justify-content-end pad">
                      <a
                        href="#"
                        className="d-flex align-items-center ps-4 blue-txt bg-white text-center"
                      >
                        Send
                      </a>
                      <a
                        href="#"
                        className="d-flex align-items-center px-3 blue-txt bg-white text-center"
                      >
                        Delete
                      </a>
                    </div>
                  </div>
                  <div className="my-hr my-3 mx-auto" />

                  {/* ----------Request view--------- */}

                  {/* ----------Request view --------- */}

                  {installerRequests.map((request, index) => (
                    <div className=" d-md-flex make_res mt-3">
                      <div className="  req-field d-sm-flex w-100" key={index}>
                        <div className="req-btn d-flex align-items-center ps-2  grey-txt">
                          {/* <i className="bi bi-camera-fill me-2" /> */}
                          <img
                            src={request.image}
                            alt=""
                            width="20px"
                            className="img-fluid me-1"
                          />
                          <button className="py-3  grey-txt">
                            {request.buttonText}
                          </button>
                        </div>

                        <div className=" d-flex px-1 align-items-center blue-txt w-100 bg-white req-fix">
                          <div
                            className={`pe-2  position-relative ${
                              request.buttonText === "Install" ||
                              request.buttonText === "Removal"
                                ? "req-text"
                                : ""
                            }`}
                          >
                            <p className="blue-txt mb-0 bs-lh">
                              Date/Time: {request.dateTime}
                            </p>
                            <p className="blue-txt mb-0 bs-lh">
                              Location: {request.location}
                            </p>
                            <p className="blue-txt mb-0 bs-lh">
                              Estimated Earnings: {request.earnings}
                            </p>
                          </div>
                          {request.buttonText === "Install" ||
                          request.buttonText === "Removal" ? (
                            <div
                              className="d-flex align-items-center ps-2 req-link"
                              onClick={() => setShow(true)}
                            >
                              <p className="blue-txt pe-2 bs-lh my-auto">
                                Choose availability
                              </p>
                              <img
                                src={require("../../assets/img/calendar.png")}
                                alt="calendar"
                                className="pe-1 calendar-icon"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="ms-2 d-flex justify-content-end req-btns mt-3 mt-md-0 pad">
                          <a
                            href="#"
                            type="submit"
                            className="d-flex align-items-center px-3 blue-txt bg-white text-center"
                          >
                            Accept
                          </a>
                          <a
                            href="#"
                            className="d-flex align-items-center px-3 blue-txt bg-white text-center"
                          >
                            Deny
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div>
                    {/* modal body  */}
                    <Modal show={show} onHide={handleClose}>
                      {/* <Modal.Header closeButton>
                                <Modal.Title></Modal.Title>
                              </Modal.Header> */}
                      <Modal.Body>
                        <h5 className="text-center p-2">
                          Select Date and Time
                        </h5>
                        {/* <RangeDatePicker/> */}
                        <div>
                          <label className="p-2" htmlFor="time">
                            Date&Time
                          </label>
                          <input
                            className="form-control"
                            type="datetime-local"
                            name=""
                            id="time"
                          />
                        </div>
                        {/* <div className='mt-3'>
                                    <label className='p-2' htmlFor="date">Date</label>
                                    <input className='form-control' type="date" name="" id="date" />
                                    </div> */}
                      </Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleClose}>
                          Save Changes
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </form>
              </div>
            </section>
            {/* ------model---- */}
            {/* <div className="d-flex justify-content-center align-items-center h-100"> */}
            {/* <div className="test request-calendar calendar h-100 w-100 position-fixed align-items-center top-0">
                  <div className="calendar-body bg-white rounded-3 border-2 w-100 mx-auto ">
                    <div className="d-flex position-relative justify-content-center">
                      <h3 className="text-center py-2 blue-txt w-100">Photoshoot Date &amp; Time</h3>
                      <div className="close-cal position-absolute text-white d-flex align-items-center">
                        <i className="bi bi-x text-white" />
                      </div>
                    </div>
                    <h4 className="text-center text-uppercase grey-txt py-2 border-2 ">December 2022</h4>
                    <div className="d-flex justify-content-between py-2 px-3 border-2 sel-week">
                      <p className="text-uppercase px-2 grey-txt">sun</p>
                      <p className="text-uppercase px-2 grey-txt">mon</p>
                      <p className="text-uppercase px-2 grey-txt">tue</p>
                      <p className="text-uppercase px-2 grey-txt">wed</p>
                      <p className="text-uppercase px-2 grey-txt">thu</p>
                      <p className="text-uppercase px-2 grey-txt">fri</p>
                      <p className="text-uppercase px-2 grey-txt">sat</p>
                    </div>
                    <section className="position-relative">
                      <span className="prev_arrow position-absolute me-3">
                        <i className="fas fa-angle-left" />
                      </span>
                      <div className="py-2 date sel-days mx-2">
                        <button className="px-2 text-center">1</button>
                        <button className="px-2 text-center">2</button>
                        <button className="px-2 text-center">3</button>
                        <button className="px-2 text-center">4</button>
                        <button className="px-2 text-center">5</button>
                        <button className="px-2 text-center">6</button>
                        <button className="px-2 text-center">7</button>
                        <button className="px-2 text-center">8</button>
                        <button className="px-2 text-center">9</button>
                        <button className="px-2 text-center">10</button>
                        <button className="px-2 text-center">12</button>
                        <button className="px-2 text-center">13</button>
                        <button className="px-2 text-center">14</button>
                        <button className="px-2 text-center active">15</button>
                        <button className="px-2 text-center">16</button>
                        <button className="px-2 text-center">17</button>
                        <button className="px-2 text-center">18</button>
                        <button className="px-2 text-center">18</button>
                        <button className="px-2 text-center">21</button>
                        <button className="px-2 text-center">22</button>
                        <button className="px-2 text-center">23</button>
                        <button className="px-2 text-center">24</button>
                        <button className="px-2 text-center">25</button>
                        <button className="px-2 text-center">26</button>
                        <button className="px-2 text-center">27</button>
                        <button className="px-2 text-center">28</button>
                        <button className="px-2 text-center">29</button>
                        <button className="px-2 text-center">30</button>
                        <button className="px-2 text-center">31</button>
                      </div>
                      <span className="next_arrow position-absolute ms-3">
                        <i className="fas fa-angle-right" />
                      </span>
                    </section>
                    <div className="d-flex justify-content-between px-4 border-2 pb-3">
                      <div className="d-flex flex-column time">
                        <p className="grey-txt py-2 mb-2 text-center">Morning</p>
                        <button className="px-3 py-3 my-1">4:00 AM</button>
                        <button className="px-3 py-3 my-1">6:00 AM</button>
                        <button className="px-3 py-3 my-1">8:00 AM</button>
                        <button className="px-3 py-3 my-1">10:00 AM</button>
                      </div>
                      <div className="d-flex flex-column time">
                        <p className="grey-txt py-2 mb-2 text-center">Afternonon</p>
                        <button className="time px-3 py-3 my-1">12:00 PM</button>
                        <button className="time px-3 py-3 my-1 active">2:00 PM</button>
                        <button className="time px-3 py-3 my-1">4:00 PM</button>
                        <button className="time px-3 py-3 my-1">6:00 PM</button>
                      </div>
                      <div className="d-flex flex-column time">
                        <p className="grey-txt py-2 mb-2 text-center">Evening</p>
                        <button className="time px-3 py-3 my-1">8:00 PM</button>
                        <button className="time px-3 py-3 my-1">10:00 PM</button>
                        <button className="time px-3 py-3 my-1">12:00 PM</button>
                        <button className="time px-3 py-3 my-1">Other</button>
                      </div>
                    </div>
                    <p className="grey-txt text-center mt-4 lead">12/15/2022; 2:00 PM</p>
                    <div className="confirm-btn w-100 mx-auto mt-2 mb-3">
                      <button className="py-3 text-white rounded-3 px-3 w-100 d-block lead">Confirm Time</button>
                    </div>
                  </div>
                </div> */}
            {/* </div> */}
            {/*-----------------------------
                 End || Payment section
                ----------------------------- */}
          </div>
        </div>
      </div>
    </div>
  );
};
